import React, { useMemo } from 'react';
import DoughnutGauge from '@/areas/dashboard/components/DoughnutGauge';
import { useCultureHubQueryParams } from '../../../hooks/useCultureHubQueryParams';
import { useGetCultureHubAnalyticsQuery } from '../../../api/cultureHubApi';

export const AssessmentCompletionMetric: React.FC = () => {
  const { assessmentPeriodId, teamId, shouldFetchData } = useCultureHubQueryParams();

  const { data: analyticsData, isLoading } = useGetCultureHubAnalyticsQuery(
    { assessmentPeriodId: assessmentPeriodId!, teamId },
    { skip: !assessmentPeriodId || !shouldFetchData }
  );

  const surveyCompletion = analyticsData?.survey_completion;
  
  const { overallCompletion, totalResponses, totalRequests } = useMemo(() => {
    if (!surveyCompletion) {
      return { overallCompletion: 0, totalResponses: 0, totalRequests: 0 };
    }
    
    return {
      overallCompletion: (surveyCompletion.percent_complete || 0) * 100,
      totalResponses: surveyCompletion.total_responses || 0,
      totalRequests: surveyCompletion.total_requests || 0,
    };
  }, [surveyCompletion]);
  
  if (isLoading) {
    return (
      <div className="card-elevated">
        <div className="text-center text-gray-500">Loading...</div>
      </div>
    );
  }
  
  if (!surveyCompletion) {
    return null;
  }
  
  return (
    <div className="card-elevated">
      <div className="flex-center-between">
        <div className="flex-grow">
          <h3 className="heading-lg mb-1">Assessment Completion</h3>
          <p className="text-sm text-gray-600 mb-2">
            {totalResponses} of {totalRequests} team members completed
          </p>
        </div>
        <div className="ml-6">
          <DoughnutGauge complete={overallCompletion} percent={true} size="small" />
        </div>
      </div>
    </div>
  );
};




